import { capitalize } from "lodash";
import getClasses from "utils/getClasses";
import styles from "./PatientTypeTag.module.scss";

interface PatientTypeTagProps {
  type: "adult" | "couple" | "minor";
}

const PatientTypeTag = ({ type }: PatientTypeTagProps) => {
  return (
    <div
      className={getClasses(
        styles["patient-type-tag"],
        styles[`patient-type-tag--${type}`],
      )}
    >
      {capitalize(type)}
    </div>
  );
};

export default PatientTypeTag;
